import React from 'react'
import './break.css'

const Break = () => {
    return (
        <div className="break section__padding">
            <h2>A Dungeons & Dragons 5th Edition Campaign</h2>
        </div>
    )
}

export default Break
